<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="700px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Sorunlu Fiş Tarihi Düzenleme İşlemi</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="standartbiletentg">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md6>
                        <blockquote>
                          Eğer var ise Sorunlu Fiş Tarihlerini Düzenleme İşlemi Yapılacaktır. Devam Edilsin mi..?
                         </blockquote>
                       
                      </v-flex>
                     
                    </v-layout>
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="close()">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ 'Güncelle' }}
            </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-dialog>
  
     
    </div>
  </template>
  
  <script>
 
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  
  export default {
    data() {
      return {
        dialog: false,
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "Sorunlu Fiş Tarihlerini Düzenle"
       
       
      };
    },
    components: {
      
      loadingcomp,
      snackbarcomp,
    },
    methods: {
        close()
        {
           this.dialog=false;
        },
      makeChange() {
        this.loadingvmodel = true
        let Params = {
       
          CompanyID: this.credentials.MuhasebeSirketNo,
          UserID:this.credentials.UserID
        
      };
      
          this.$http.post(auth.API_URL + 'api/AccountingParameters/BugfixBadRecieptDates', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
     
    },
  };
  </script>
  
  <style>
  </style>
  